export default "__VITE_ASSET__ZsfqMMJU__"